import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Idea, IdeaAccessors, w2d2dApiClient } from "../../../../w2d2d-api-client";
import { W2d2dNavigation } from "../../../../W2d2dNavigation.tsx";
import AnnounceIdeaPage from "./announce-idea-page.tsx";
import { Typography } from "@mui/material";

export default function AnnounceIdeaRoute() {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();

    const [idea, setIdea] = useState<undefined | null | Idea>(undefined);
    const [accessors, setAccessors] = useState<undefined | null | IdeaAccessors>(undefined);

    useEffect(() => {
        if (!id) {
            W2d2dNavigation.ideas.navigate(navigate, location);
            return;
        }

        w2d2dApiClient.getIdea({ id })
            .then(setIdea)
            .catch(() => setIdea(null));

        w2d2dApiClient.getIdeaAccessors({ id })
            .then(setAccessors)
            .catch(() => setAccessors(null));

    }, [id, navigate, location]);

    const handleClose = () => {
        // Navigate back to the idea or event view?
        // Usually overlays close by navigating back to 'from' state or parent route.
        // If we are at /ideas/:id/announce, typically we want to go back to parent of this action.
        // Which might be the event view or idea view.
        // W2d2dNavigation usually handles 'from' state if passed.
        // For now, let's navigate to the idea view or just back().

        // Actually, checking how EditIdeaPage does it:
        // W2d2dNavigation.ideas.navigate(navigate, location) -> goes to list?
        // Or depends on where we came from.
        // If we just go strictly back:
        navigate(-1);
    };

    if (idea === undefined || accessors === undefined) {
        // Loading
        return null;
    }

    if (idea === null || accessors === null) {
        return <Typography>Idee nicht gefunden</Typography>;
    }

    return (
        <AnnounceIdeaPage
            idea={idea}
            accessors={accessors}
            onClose={handleClose}
        />
    );
}
